import posthog from 'posthog-js'
import { ANALYTICS_EVENTS } from './events'

const POSTHOG_API_KEY = 'phc_Jt7bHCQmUWThQD4d1K9CZ4AYgLm69dPpy5zEpXyrLRg'
const POSTHOG_HOST = 'https://us.i.posthog.com'

const VALID_EVENTS = new Set(Object.values(ANALYTICS_EVENTS))

let initialized = false
let commonContext = {
  platform: 'web',
}

export const initAnalytics = ({ userToken, appVersion = null, nickname = null }) => {
  if (initialized) {
    return
  }

  if (window.location.protocol !== 'https:') {
    return
  }

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
  })

  if (userToken) {
    posthog.identify(userToken)
  }

  commonContext = {
    ...commonContext,
    userToken: userToken || null,
    appVersion: appVersion || null,
    nickname: typeof nickname === 'string' && nickname.trim() ? nickname.trim() : null,
  }
  initialized = true
}

export const identifyAnalyticsUser = (userToken) => {
  if (!initialized || !userToken) {
    return
  }
  posthog.identify(userToken)
  commonContext = {
    ...commonContext,
    userToken,
  }
}

export const setAnalyticsNickname = (nickname) => {
  if (!initialized) {
    return
  }
  commonContext = {
    ...commonContext,
    nickname: typeof nickname === 'string' && nickname.trim() ? nickname.trim() : null,
  }
}

export const trackEvent = (eventName, properties = {}) => {
  if (!initialized || !eventName) {
    return
  }

  if (!VALID_EVENTS.has(eventName)) {
    console.warn(`[analytics] Unknown event "${eventName}"`)
  }

  posthog.capture(eventName, {
    ...commonContext,
    ...properties,
  })
}
